import { RightOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, Col, DatePicker, Form, Input, PageHeader, Row, Select, Space } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import { useParams } from "react-router-dom";
import accountService from "../../api/account.service";
import commonService from "../../api/common.service";
import ProgrammeService from '../../api/programme.service'
import AdminBreadCrumb from '../../components/layout/AdminBreadCrumb'
import PaymentPaidList from '../../components/payment/PaymentPaidList'
import VoucherListView from "../../components/voucher/VoucherListView";
import { DATE_FORMAT_DMY_SLASH, SUCCESS_STATUS } from '../../utility/Constants'
import commonUtility from "../../utility/Utils";
const { Option } = Select;


const AccountReport = () => {
    const params = useParams();
    const [form] = Form.useForm();
    const [accountList, setAccountList] = useState([]);
    const [accountGroupList, setAccountGroupList] = useState([]);
    const [selectedFromDate, setSelectedFromDate] = useState("");
    const [selectedEndDate, setSelectedEndDate] = useState("");
    const [selectedTranType, setSelectedTranType] = useState("");
    const [selectedAccountID, setSelectedAccountID] = useState("");
    const [selectedAccountGroupID, setSelectedAccountGroupID] = useState("");
    const [reportTag, setReportTag] = useState("");
    const [reportHeader, setReportHeader] = useState("");

    const [isAccountRequired, setIsAccountRequired] = useState(false);
    const [isAccountGroupRequired, setIsAccountGroupRequired] = useState(false);

    const buttonref = useRef(null);
    const [isPostReturnUrlAvailable,setIsPostReturnUrlAvailable] = useState(false);
    const [redirectLink,setRedirectLink] = useState('');


    const onAccountSelect = (value, event) => {

        const account_id = form.getFieldValue("account_id");
        setSelectedAccountID(account_id)

    };

    

    const onAccountGroupSelect = (value, event) => {

        const group_id = form.getFieldValue("group_id");
        setSelectedAccountGroupID(group_id)

    };

  
    const onFromDateChange = (date, dateString) => {
        // console.log(date, dateString);
        setSelectedFromDate(dateString)
        form.setFieldsValue({
            from_date : dateString
        });
    };

    const onEndDateChange = (date, dateString) => {
        // console.log(date, dateString);
        setSelectedEndDate(dateString)
        form.setFieldsValue({
            to_date : dateString
        });
        
    };


  


    const onPostClick = async (values) => {
        setIsPostReturnUrlAvailable(false)
        // const formdata = {
        //   fromdate:'01/04/2022',
        //   todate:'31/03/2023',
        //   companyId:1,
        //   yearid:2,
        //   // account_id:10,
        // }

        const data = { formdata: values };
        console.log("Form Data",values);


      const response =  ProgrammeService.accountReportLink(data).then((resdata) => {
        let dataPdf = resdata.data;
        setIsPostReturnUrlAvailable(true)
          //buttonref.current.click();
          // console.log("Link = ",resdata.data.link)
          console.log(resdata)
           let url = "http://btaportal.in/custom/report/" + resdata.data.link
           setRedirectLink(url)
        });
       
      
      };




      const openInNewTab = (url) => {
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
      }
    

      useEffect(() => {
        accountService.accountList().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setAccountList(res.data.response_data);
            }

        });
    }, []);

    useEffect(() => {
        accountService.accountGroupList().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setAccountGroupList(res.data.response_data);
            }

        });
    }, []);

    useEffect(() => {
        const tag = params.tag;
        form.setFieldsValue({
            tag : tag
        });
        setReportTag(tag)
    }, [params.tag])


    useEffect(() => {
        const optiontype = params.optiontype;
        
        if(optiontype == "A") {
            setIsAccountRequired(true)
            setIsAccountGroupRequired(false)
        }
        else if(optiontype == "G") {
            setIsAccountGroupRequired(true)
            setIsAccountRequired(false)
        }
        else if(optiontype == "AG") {
            setIsAccountGroupRequired(true)
            setIsAccountRequired(true)
        }
        else{
            setIsAccountRequired(false)
            setIsAccountGroupRequired(false)
        }

    }, [params.optiontype])



      useEffect(() => {
        if(isPostReturnUrlAvailable) {
          buttonref.current.click();
        }
        
      },[isPostReturnUrlAvailable])



    useEffect(()=>{
        const data = { formdata: {
            'tag':reportTag
        } };
        
        commonService.accountReportLink(data).then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                const res_data = res.data.response_data[0];
                setReportHeader(res_data.head_name)
            }

        });
    },[reportTag])


    return (
        <div>


            <div className="inside-main-content">
                <AdminBreadCrumb />

                <div className="box-style">
                    <PageHeader
                        ghost={false}
                        onBack={() => window.history.back()}
                        title={reportHeader}
                        subTitle=""

                    ></PageHeader>

                    <div className="">

                        <div className="form-content" style={{
                            background:'#f7f7f7',
                            boxShadow:'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                        }}>

                            <Row className="" style={{ background: "transparent" }}>
                                <Col className="" xs={24} xl={24}>
                                    <Form
                                        form={form}
                                        layout="vertical"
                                        onFinish={onPostClick}
                                        autoComplete="off"
                                    // initialValues={formDefaultValues}
                                    >

                                        <Row gutter={20} >

                                            <Col xs={24} xl={5} >

                                                <Form.Item name="from_date_picker" label="From Date" rules={[
                                                    {
                                                        required: true,
                                                        message: 'Start date is required',
                                                    },
                                                ]}>
                                                    <DatePicker
                                                        format={DATE_FORMAT_DMY_SLASH}
                                                        onChange={onFromDateChange}
                                                        style={{ width: "100%" }}
                                                        inputReadOnly={true}
                                                    />
                                                </Form.Item>
                                                <Form.Item name="from_date" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={24} xl={5} >

                                                <Form.Item name="to_date_picker" label="End Date" rules={[
                                                    {
                                                        required: true,
                                                        message: 'End date is required',
                                                    },
                                                ]}>
                                                    <DatePicker
                                                        format={DATE_FORMAT_DMY_SLASH}
                                                        onChange={onEndDateChange}
                                                        style={{ width: "100%" }}
                                                        inputReadOnly={true}
                                                    />
                                                </Form.Item>
                                                <Form.Item name="to_date" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                <Form.Item name="tag" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>

                                            </Col>

                                          
                                            <Col xs={24} xl={8} hidden={!isAccountGroupRequired}>
                                                <Form.Item name="group_id" label="Group" rules={[
                                                    {
                                                        required: isAccountGroupRequired,
                                                        message: 'Group is required',
                                                    },
                                                ]}>
                                                    <Select className="text-left" onSelect={onAccountGroupSelect}
                                                    showSearch
                                                    placeholder="Search to Select"
                                                    optionFilterProp="children"
                                                    filterOption={(input, option) =>
                                                        //option.children.includes(input)
                                                        option.children.toLowerCase().includes(input.toLowerCase())
                                                    }
                                                    filterSort={(optionA, optionB) =>
                                                        optionA.children
                                                            .toLowerCase()
                                                            .localeCompare(optionB.children.toLowerCase())
                                                    }
                                                    placement="bottomLeft"
                                                    allowClear={true}
                                                    
                                                    >
                                                    <Option key="" value="">Select</Option> 

                                                        {
                                                            accountGroupList.length > 0 ?
                                                            accountGroupList.map(account_group_data => (
                                                                    <Option key={account_group_data.group_id} value={account_group_data.group_id}>{account_group_data.group_description}</Option>

                                                                ))
                                                                : ''
                                                        }
                                                    </Select>
                                                </Form.Item>
                                            </Col>

                                            <Col xs={24} xl={8} hidden={!isAccountRequired}>
                                                <Form.Item name="account_id" label="Account" 
                                                rules={[
                                                    {
                                                        required: isAccountRequired,
                                                        message: 'Account is required',
                                                    },
                                                ]}
                                                >
                                                    <Select className="text-left" onSelect={onAccountSelect}
                                                    showSearch
                                                    placeholder="Search to Select"
                                                    optionFilterProp="children"
                                                    filterOption={(input, option) =>
                                                        //option.children.includes(input)
                                                        option.children.toLowerCase().includes(input.toLowerCase())
                                                    }
                                                    filterSort={(optionA, optionB) =>
                                                        optionA.children
                                                            .toLowerCase()
                                                            .localeCompare(optionB.children.toLowerCase())
                                                    }
                                                    placement="bottomLeft"
                                                    allowClear={true}
                                                    >
                                                    <Option key="" value="">Select</Option> 

                                                        {
                                                            accountList.length > 0 ?
                                                                accountList.map(account_data => (
                                                                    <Option key={account_data.id} value={account_data.id}>{account_data.account_name}</Option>

                                                                ))
                                                                : ''
                                                        }
                                                    </Select>
                                                </Form.Item>
                                            </Col>


                                            <Col xs={24} xl={3}>
                                                <Form.Item label=" ">
                                                    <Button
                                                        htmlType="submit"
                                                        shape="round"

                                                        className="custom-button-green"
                                                    >
                                                        Search <SearchOutlined />
                                                    </Button>
                                                    <Button hidden={true} ref={buttonref} onClick={() => openInNewTab(redirectLink)} >Get Pdf</Button>
                                                </Form.Item>
                                            </Col>





                                        </Row>
                                    </Form>



                                </Col>
                            </Row>


                          


                        </div>
                    </div>

                </div>
            </div>

        </div>


    )
}

export default AccountReport